import { ActivatedRoute } from '@angular/router';
import { Page } from '../../../../models/paging/page';
import { CylHistoryService } from '../../../../services/cyl-history.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cylinder-history',
  templateUrl: './cylinder_history.component.html',
  styleUrls: ['./cylinder_history.component.css']
})
export class CylinderHistoryComponent implements OnInit {
  showHistory = false;

  cylinder_Id: number;
  cylinder_Serial_No: string;

  historyData: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private cylHistoryService: CylHistoryService
  ) { }

  ngOnInit(): void {
    const params = this.route.snapshot.queryParams;

    const idFromQuery = params['cylinder_Id'];
    const serialFromQuery = params['cylinder_Serial_No'];

    if (idFromQuery) {
      this.cylinder_Id = +idFromQuery;
      this.cylinder_Serial_No = serialFromQuery;

      this.loadHistory();
      return;
    }

    try {
      const stored = localStorage.getItem('selectedCylinder');
      if (stored) {
        const { cylinder_Id, cylinder_Serial_No } = JSON.parse(stored);
        if (cylinder_Id) {
          this.cylinder_Id = +cylinder_Id;
          this.cylinder_Serial_No = cylinder_Serial_No;
          this.loadHistory();
          return;
        }
      }
    } catch (e) {
      console.warn('Could not read selected cylinder from localStorage', e);
    }

  }

  loadHistory(): void {
    if (!this.cylinder_Id) return;

    this.showHistory = true;

    const page = new Page();
    page.pageNumber = 0;
    page.size = 10;

    this.cylHistoryService.getResults(page, this.cylinder_Id, '').then(
      (pagedData) => {
        this.historyData = pagedData.data;
      },
      (err) => {
        console.error('Error loading cylinder history:', err);
      }
    );
  }
}
